exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-content[data-v-470c68c6]{\n    width: 100% !important;\n    position: absolute !important;\n}\n.modal-lg-charge[data-v-470c68c6] {\n    height: 90%;\n    max-width: 99%;\n}\n.show[data-v-470c68c6]{\n    display: list-item !important;\n    opacity: 1 !important;\n    background-color: #3c29297a !important;\n    position: fixed;\n    overflow-y: auto;\n}\n", ""]);

// exports
